var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"amazing-exp-main py-2",class:{ 'active': _vm.feedbackRating === 1 }},[_vm._v("😄"),_c('span',[_vm._v(_vm._s(_vm.$t('feedbackForm.amazingExp')))])])}
var staticRenderFns = []

export { render, staticRenderFns }